import { render, staticRenderFns } from "./ContentElementsDialog.vue?vue&type=template&id=7e4f5088&scoped=true"
import script from "./ContentElementsDialog.vue?vue&type=script&lang=ts"
export * from "./ContentElementsDialog.vue?vue&type=script&lang=ts"
import style0 from "./ContentElementsDialog.vue?vue&type=style&index=0&id=7e4f5088&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e4f5088",
  null
  
)

export default component.exports